export default "__VITE_ASSET__B93OhppV__"